module.exports = __webpack_public_path__ + "img/gys_21@2x.05eb4d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_21@2x.png
// module id = Szk2
// module chunks = 0